import { StorageHelper } from "./storageHelper";

const key = (patientId) =>
  `mgp_pending_encounter_comments_${String(patientId)}`;

export const readPendingComments = (patientId) => {
  if (patientId == null || patientId === "") return [];
  try {
    const raw = StorageHelper.get(key(patientId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const writePendingComments = (patientId, list) => {
  if (patientId == null || patientId === "") return;
  StorageHelper.set(key(patientId), JSON.stringify(list));
};

export const appendPendingComment = (patientId, entry) => {
  const { attributeId, section, label, comment, username, created_on } =
    entry;
  if (
    patientId == null ||
    patientId === "" ||
    !attributeId ||
    !String(comment || "").trim()
  ) {
    return readPendingComments(patientId);
  }
  const list = readPendingComments(patientId);
  list.push({
    attributeId,
    section: section || "",
    label: label || "",
    comment: String(comment).trim(),
    username: username || "You",
    created_on:
      created_on != null && created_on !== ""
        ? created_on
        : Date.now(),
  });
  writePendingComments(patientId, list);
  return list;
};

export const clearPendingComments = (patientId) => {
  if (patientId == null || patientId === "") return;
  StorageHelper.remove(key(patientId));
};

export const getPendingCommentCounts = (patientId) => {
  const list = readPendingComments(patientId);
  return list.reduce((acc, row) => {
    const id = row.attributeId;
    if (!id) return acc;
    acc[id] = (acc[id] || 0) + 1;
    return acc;
  }, {});
};

export const getPendingCommentsForAttribute = (patientId, attributeId) => {
  return readPendingComments(patientId).filter(
    (row) => row.attributeId === attributeId
  );
};
